<template>
    <div>
        <a href="/">
            <img :src="'/images/login-logo.png'" alt="Talk360" />
        </a>
    </div>
</template>
